import React from 'react';

const PorQueLambrin = () => {
  return (
    <section>
      <div className="container">
        {/* Título */}
        <div className="title-style4 mb-1-9 text-center">
          <h2>
            <span>Por qué</span>
            <span className="text-primary"> Elegir Lambrin</span>
          </h2>
        </div>

        {/* Tarjetas */}
        <div className="row g-5 mt-n1-9 mb-2-5">
          {[
            {
              imgSrc: "/assets/img/icons/icon-palomita-verde.png",
              title: "Disponibilidad Inmediata",
              description: "Evita retrasos en tus proyectos, en Decototal contamos con lambrin en stock siempre.",
              delay: "150ms",
            },
            {
              imgSrc: "/assets/img/icons/icon-palomita-verde.png",
              title: "Compromiso con la Sostenibilidad",
              description: "Fabricado con materiales ecológicos que reducen el impacto ambiental sin comprometer la calidad.",
              delay: "300ms",
            },
            {
              imgSrc: "/assets/img/icons/icon-palomita-verde.png",
              title: "Asesoría Especializada",
              description: "Nuestro equipo de expertos está listo para ayudarte a elegir el acabado y diseño perfectos para tu proyecto",
              delay: "450ms",
            },
            {
              imgSrc: "/assets/img/icons/icon-palomita-verde.png",
              title: "Respaldo de Calidad",
              description: "Diseñado para soportar las demandas de los proyectos más exigentes, con garantía de durabilidad y rendimiento.",
              delay: "600ms",
            },
          ].map((card, index) => (
            <div
              className="col-md-6 col-xl-3 mt-1-9 wow fadeInUp"
              data-wow-delay={card.delay}
              key={index}
            >
              <div className="card card-style17 border-0">
                <div className="card-body">
                  <div className="card-image mb-1-9">
                    <img src={card.imgSrc} alt="..." className="w-75px" />
                  </div>
                  <div className="card-content">
                    <h2>{card.title}</h2>
                    <p className="mb-0 text-muted">{card.description}</p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Enlace adicional */}
        <div className="text-center wow fadeIn" data-wow-delay="400ms">
          <p className="mb-0">
            Cotiza ahora{" "}
            <a
              className="text-dark border-bottom border-color-black text-primary-hover"
              href="contacto-decototal"
            >
              Ver más
            </a>
          </p>
        </div>
      </div>
    </section>
  );
};

export default PorQueLambrin;
